<template>
  <collapsed-section title="Emergency Contact">
    <error-banner v-if="error" :message="error"/>
    <labeled-form-control label="Name" :optional="true">
      <input v-model="name" class="form-control" type="text" placeholder="Name" :disabled="alternateContactUpdated"/>
    </labeled-form-control>
    <labeled-form-control label="Mobile" :optional="true">
      <input v-model="mobile" class="form-control" type="tel" placeholder="Mobile" :disabled="alternateContactUpdated"/>
    </labeled-form-control>
  </collapsed-section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { AlternateContactUploadMixin } from '../../mixins/Registration/AlternateContactUploadMixin'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import CollapsedSection from '../Layout/CollapsedSection.vue'
import LabeledFormControl from '../Layout/LabeledFormControl.vue'
import ErrorBanner from '@/components/ErrorValidation/ErrorBanner.vue'

export default {
  name: 'ClientEmergencyContactSection',
  mixins: [AlternateContactUploadMixin, ClientOnboardingInviteCacheMixin],
  computed: {
    ...mapState('ApplicationEvents', [
      'saveRegistrationEvent'
    ]),
    ownerId () {
      return this.clientOnboardingInvite ? this.clientOnboardingInvite.clientId : ''
    }
  },
  watch: {
    saveRegistrationEvent () {
      this.handleUpdateEvent()
    },
    vetContactUpdated () {
      this.handleUpdateEvent()
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setAlternateContactUpdated'
    ]),
    afterUpdateAlternateContact () {
      this.setAlternateContactUpdated()
    },
    afterAddAlternateContact () {
      this.setAlternateContactUpdated()
    },
    handleUpdateEvent () {
      if (!this.alternateContactUpdated && this.vetContactUpdated) {
        this.tryUploadAlternateContact()
      }
    }
  },
  components: {
    'collapsed-section': CollapsedSection,
    'labeled-form-control': LabeledFormControl,
    'error-banner': ErrorBanner
  }
}
</script>
